export default __webpack_public_path__ + "static/media/badzimmer.91790e7e.jpg";